import React from "react";
import {
  MDBBadge,
  MDBBtn,
  MDBBtnGroup,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBInput,
} from "mdb-react-ui-kit";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Form from "react-bootstrap/Form";

import "../sso-management.css";
import "./GestionAplicaciones.css";

import profile_default from "images/profile_default.png";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { CircleImage } from "Projects/CC_cubi_clan_project/GlobalComponents/CircleImage/CircleImage";
import { mfmMediumUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";
import { AppEditModal } from "../AppEditModal/AppEditModal";

export class GestionAplicaciones extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      filterText: "",
      filterEstado: "",
      showAppEditModal: false,
      selectedAppEdit: null,
      showAppNewModal: false,
    };
  }

  componentDidMount() {
    this.getApps();
  }

  getApps() {
    this.props.onLoading(true);

    doFetch("SSO", "getAllAplicaciones", null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ data: data.DATA });
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  getStatusColor(element) {
    switch (element.estado) {
      case "ONLINE":
        return "success";
      case "DEMO":
        return "info";
      case "DISABLED":
        return "danger";
      case "INCOMPLETA":
        return "warning";
      default:
        return "secondary";
    }
  }

  setEditApp(element) {
    this.setState({ showAppEditModal: true, selectedAppEdit: element });
  }

  handleCloseModal() {
    this.setState({ showAppEditModal: false, showAppNewModal: false });
    this.getApps();
  }

  setNewApp() {
    this.setState({ showAppNewModal: true });
  }

  render() {
    const filtered = this.state.data.filter((el) => {
      if (this.state.filterText.trim()) {
        const f = this.state.filterText.toLowerCase();
        if (
          !(el.titulo || "").toLowerCase().includes(f) &&
          !(el.nombre || "").toLowerCase().includes(f) &&
          !(el.descripcion || "").toLowerCase().includes(f)
        )
          return false;
      }
      if (this.state.filterEstado && el.estado !== this.state.filterEstado) return false;
      return true;
    });

    return (
      <MDBContainer fluid>
        {this.state.showAppEditModal ? (
          <AppEditModal
            showAppEditModal={this.state.showAppEditModal}
            data={this.state.selectedAppEdit}
            onCloseModal={() => this.handleCloseModal()}
            onLoading={(event) => this.props.onLoading(event)}
          />
        ) : (
          <></>
        )}
        {this.state.showAppNewModal ? (
          <AppEditModal
            showAppEditModal={this.state.showAppNewModal}
            data={{}}
            onCloseModal={() => this.handleCloseModal()}
            onLoading={(event) => this.props.onLoading(event)}
          />
        ) : (
          <></>
        )}
        <MDBContainer fluid className="mt-3 mb-2">
          <MDBRow className="align-items-end g-2">
            <MDBCol md="3">
              <MDBInput
                type="text"
                size="sm"
                label="Buscar aplicación..."
                value={this.state.filterText}
                onChange={(e) => this.setState({ filterText: e.target.value })}
              />
            </MDBCol>
            <MDBCol md="2">
              <Form.Select
                size="sm"
                value={this.state.filterEstado}
                onChange={(e) => this.setState({ filterEstado: e.target.value })}
              >
                <option value="">Todos los estados</option>
                <option value="ONLINE">ONLINE</option>
                <option value="DEMO">DEMO</option>
                <option value="DISABLED">DISABLED</option>
                <option value="INCOMPLETA">INCOMPLETA</option>
              </Form.Select>
            </MDBCol>
            <MDBCol md="7" className="d-flex justify-content-end">
              <MDBBtnGroup>
                <MDBBtn size="sm" onClick={() => this.setNewApp()}>
                  <MDBIcon icon="plus" className="me-1" /> Nueva aplicación
                </MDBBtn>
              </MDBBtnGroup>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
        <MDBTable align="middle" hover responsive className="sso-mgmt-table">
          <MDBTableHead>
            <tr>
              <th scope="col">Aplicación</th>
              <th scope="col">Descripción</th>
              <th scope="col" style={{ width: "80px" }}>
                <div className="text-center">Pública</div>
              </th>
              <th scope="col" style={{ width: "110px" }}>
                <div className="text-center">Estado</div>
              </th>
              <th scope="col" style={{ width: "80px" }}>Acciones</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {filtered.map((element, index) => (
              <tr key={index}>
                <td>
                  <div className="d-flex align-items-center">
                    <CircleImage
                      src={element.imageUuid ? mfmMediumUrl(element.imageUuid) : (element.appImg || profile_default)}
                      fallbackSrc={element.appImg || profile_default}
                      alt={element.titulo}
                      size="40px"
                      enlargeOnHover={true}
                      onClick={() => this.setEditApp(element)}
                    />
                    <div className="ms-3">
                      <p className="fw-bold mb-0" style={{ fontSize: "0.85rem" }}>{element.titulo}</p>
                      <p className="text-muted mb-0" style={{ fontSize: "0.78rem" }}>{element.nombre}</p>
                    </div>
                  </div>
                </td>
                <td>
                  {element.descripcion || <span className="text-muted">Sin descripción</span>}
                </td>
                <td className="text-center">
                  <MDBIcon
                    fas
                    icon={element.publica ? "globe" : "lock"}
                    className={element.publica ? "text-success" : "text-muted"}
                    title={element.publica ? "Pública" : "Privada"}
                  />
                </td>
                <td>
                  <div className="d-flex justify-content-center">
                    <MDBBadge
                      color={this.getStatusColor(element)}
                      pill
                    >
                      {element.estado}
                    </MDBBadge>
                  </div>
                </td>
                <td className="sso-actions-cell">
                  <OverlayTrigger placement="top" overlay={<Tooltip>Editar</Tooltip>}>
                    <span className="d-inline-block">
                      <MDBBtn color="primary" outline className="mx-1" floating size="sm" onClick={() => this.setEditApp(element)}>
                        <MDBIcon icon="edit" />
                      </MDBBtn>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
            ))}
          </MDBTableBody>
        </MDBTable>
      </MDBContainer>
    );
  }
}
